import { EntityStatus } from "@/enums";
import {
  getCategoryFields,
  getFlatFormFields,
  getFormCategories,
} from "@/helpers";

export const shapeDynamicDetails = (
  formConfig,
  dynamicData,
  fieldTypesToFilter
) => {
  const details = [];

  const flatFormFields = getFlatFormFields(formConfig);
  const categories = getFormCategories(flatFormFields);

  categories?.forEach((category) => {
    details.push({
      label: {
        id: category.id,
        fallback: category.fallback,
      },
      fields: shapeFields(
        category,
        flatFormFields,
        dynamicData,
        fieldTypesToFilter
      ),
    });
  });

  return details;
};

const shapeFields = (
  category,
  flatFormFields,
  dynamicData,
  fieldTypesToFilter
) => {
  const categoryFields = getCategoryFields(category, flatFormFields);

  const fields = [];

  categoryFields?.forEach(
    ({ property: { status, name, label, fieldType, url } }) => {
      if (status !== EntityStatus.Active || !dynamicData[name]) return;

      fields.push({
        name,
        label: {
          id: label.id,
          fallback: label.fallback,
        },
        type: fieldType,
        value: dynamicData[name],
        url: url,
      });
    }
  );

  return fieldTypesToFilter
    ? fields.filter(({ type }) => !fieldTypesToFilter.includes(type))
    : fields;
};
